<script setup lang="ts">
const props = defineProps<{
  icon?: string
  title: string
  description?: string
  to: string
  quickLink?: boolean
}>()
</script>

<template>
  <div
    class="flex items-start gap-2 px-4 relative hover:bg-surface-container-low rounded-lg"
    :class="[props.quickLink ? 'py-2' : 'py-4']"
  >
    <div
      v-if="props.icon"
      class="shrink-0 p-1 bg-surface-container-low text-primary rounded-full"
    >
      <Icon :name="props.icon" size="24px" />
    </div>
    <div class="grow flex flex-col gap-1">
      <h5
        class="text-sm"
        :class="
          props.quickLink
            ? 'text-outline font-medium'
            : 'text-on-surface-variant font-semibold'
        "
      >
        {{ props.title }}
      </h5>
      <p v-if="props.description" class="text-sm text-outline">
        {{ props.description }}
      </p>
    </div>
    <NuxtLink :to="props.to" class="absolute cursor-pointer inset-0" />
  </div>
</template>
